"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarbreakerEffectHandler = exports.StarbreakerEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class StarbreakerEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Starbreaker;
        this.__typeName = "Starbreaker";
        this.name = "Starbreaker";
        this.harmful = false;
    }
}
exports.StarbreakerEffectArgs = StarbreakerEffectArgs;
let StarbreakerEffectHandler = class StarbreakerEffectHandler {
    apply(sequence, container, state) {
        state.meta.damageAmplifyEffectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.creatorId,
            effect: new _1.DamageAmplifyEffectArgs(100),
            duration: Duration_1.Duration.Permanent,
        });
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_Starbreaker_OnAttack", {}));
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.damageAmplifyEffectId);
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
StarbreakerEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Starbreaker)
], StarbreakerEffectHandler);
exports.StarbreakerEffectHandler = StarbreakerEffectHandler;
